import * as React from 'react';
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import { Routes, Route } from 'react-router-dom';
import { Theme } from '@mui/styles';
import AppView from '~common/components/app-view/index';
import FormBasedEditor from '~common/form/form-based-editor';

import DefinitionDataProvider from "~common/form/icg-definition-data-provider";
import FormBasedContainer from "~common/form/form-based-container-fc";
import {ContainerTypeEditor} from "~common/form/form-based-container-fc";
import Require from "~common/components/require";


const styles = (theme: Theme): StyleRules => ({
	container: {
		width: '100%'
	}
});

interface Props extends React.HTMLProps<HTMLDivElement> {
	history: any;
}

type State = {};

class InviteBulk extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
	constructor(props: Props & WithStyles<keyof typeof styles>) {
		super(props, {});
		this.state = {};
	}

	UNSAFE_componentWillReceiveProps(newProps: Props & WithStyles<keyof typeof styles>) {}

	render() {

    const {match} = this.props;
		const { classes }: { classes: ClassNameMap } = this.props;

		return (
			<div className={classes.container}>
				<AppView history={this.props.history}>
					<Require classes={{}} requireOneOfFeatures={["invite_bulk_portal_users"]}>
						<DefinitionDataProvider>
							<FormBasedContainer
								containerType={ContainerTypeEditor} 
								history={this.props.history} 
								match={match}
								clearDataOnSubmit={true}
								postOnly={true}
								dataUrl="/api/portal-users/invite/bulk"
								formSelector={{"formType": "inviteBulkPortalUsers", "modules": "users", "userType": "Internal"}}
								successMessage="The invitations will be sent.  You will receive a confirmation email when this is complete"
								submitButtonText="Send Invitations"
								returnURL={"/"}
							>
							</FormBasedContainer>
						</DefinitionDataProvider>
					</Require>
        		</AppView>
			</div>
		);
	}
}

export default withStyles(styles)(InviteBulk);
